import { useLazyQuery } from '@apollo/client'
import { css, StyleSheet } from 'aphrodite'
import { Auth } from 'aws-amplify'
import { PropTypes } from 'prop-types'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import PictoMaker from '../../assets/picto-maker.svg'
import PictoViewer from '../../assets/picto-viewer.svg'
import LiveContext from '../../components/Context/LiveContext'
import INT from '../../config/index'
import GET_REQUEST_COUNT from '../../graphql/Requests/queries/CheckIfHaveRequest'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'
import { COLOR_GRAY_700, COLOR_WHITE } from '../../lib/colors'
import LoginPopup from '../../pages/Login/LoginPopup'
import RegisterWatcher from '../../pages/Watcher/RegisterWatcher'
import UIButton from '../UI/UIButton'
import UILogo from '../UI/UILogo'

const styles = StyleSheet.create({
  picto: {
    width: '26px',
    height: '30px',
  },
  buttonBeSomethingLeft: {
    background: 'rgba(0,0,0, 0.3)',
    color: 'white',
    width: '200px',
    height: '45px',
    borderRight: 'solid 1px black',
    borderTopLeftRadius: '37px',
    borderBottomLeftRadius: '37px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    alignItems: 'center',
    paddingRight: '15px',
  },
  buttonBeSomethingLeftText: {
    paddingRight: '15px',
    fontFamily: 'Helvetica',
    fontSize: '20px',
  },
  buttonBeSomethingRightText: {
    paddingLeft: '15px',
    fontFamily: 'Helvetica',
    fontSize: '20px',
  },
  beSomethingDiv: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '15px',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  buttonBeSomethingRight: {
    background: 'rgba(0,0,0, 0.3)',
    color: 'white',
    width: '200px',
    height: '45px',
    borderLeft: 'solid 1px black',
    borderTopRightRadius: '37px',
    borderBottomRightRadius: '37px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: '15px',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    padding: '0 20px',
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    color: COLOR_WHITE,
    marginTop: '20px',
    '@media (max-width: 480px)': {
      maxWidth: '50%',
      marginTop: 0,
      marginRight: 10,
    },
  },
  loginButton: {
    borderRadius: '50px',
    backgroundColor: COLOR_WHITE,
    color: COLOR_GRAY_700,
    fontWeight: 700,
    margin: 0,
    padding: '5px 10px',
    [MEDIA_MIN_SM]: {
      padding: '10px 30px',
      margin: '0px 15px',
    },
  },
  text: {
    fontWeight: 700,
    letterSpacing: '-0.05em',
    lineHeight: '14px',
  },
  link: {
    textDecoration: 'none',
    color: COLOR_WHITE,
    fontSize: '18px',
  },
  logo: {
    margin: '20px 20px',
    width: '20px',
    flexGrow: 1,
  },
})

function WidgetHomeHeader({ dynamicStyle, uiLogoDark, smallSize }) {
  const { t } = useTranslation('translation')
  const navigate = useNavigate()

  const [isLoginOpened, setLoginOpened] = useState(false)
  const [isRegisterOpened, setRegisterOpened] = useState(false)

  const [getRequestsCount] = useLazyQuery(GET_REQUEST_COUNT, {
    onCompleted: (data) => {
      console.log({ data: data.requests.totalCount })
      if (data.requests.totalCount > 0) navigate('/account/demand')
      else navigate('/account/account')
    },
  })

  const { isUserLogged, userRole, setUserLogged } = useContext(LiveContext)

  const handleLogin = () => {
    if (isUserLogged) {
      if (userRole === 'ubiqeyes_watcher') {
        navigate('/account')
      } else {
        localStorage.removeItem('access_token')
        localStorage.removeItem('userMaker')
        Auth.signOut({ global: false }).then(() => {
          setUserLogged(false)
          toast.success(t('pages.login.loggedOut'))
        })
      }
    } else {
      setLoginOpened(true)
    }
  }

  const handleLoginClose = () => {
    setLoginOpened(false)
  }

  const handleRegisterClose = () => {
    setRegisterOpened(false)
  }

  const handleCreateAccount = () => {
    setLoginOpened(false)
    setRegisterOpened(true)
  }

  const handleSubmitRegister = () => {
    setLoginOpened(true)
    setRegisterOpened(false)
  }

  const onLoginSuccess = () => {
    Auth.currentSession().then((data) => {
      const idWatcher = data.accessToken.payload.sub
      getRequestsCount({
        variables: {
          idWatcher,
        },
      })
    })
  }

  return (
    <>
      <div
        className={css(styles.container, dynamicStyle ? dynamicStyle : null)}
      >
        <UILogo logoWhite={!uiLogoDark} dynamicStyle={styles.logo} />
        {!smallSize && (
          <div className={css(styles.beSomethingDiv)}>
            <span className="headermaker">
              <Link to="/be-a-maker" style={{ textDecoration: 'none' }}>
                <div className={css(styles.buttonBeSomethingLeft)}>
                  <p className={css(styles.buttonBeSomethingLeftText)}>
                    {t('pages.home.makerVsWatcher.BeAMaker')}
                  </p>
                  <img
                    src={PictoMaker}
                    className={css(styles.picto)}
                    alt="picto maker"
                    width="auto"
                    height="9em"
                  />
                </div>
              </Link>
            </span>
            <span className="headerviewer">
              <Link to="/be-a-viewer" style={{ textDecoration: 'none' }}>
                <div className={css(styles.buttonBeSomethingRight)}>
                  <img
                    src={PictoViewer}
                    className={css(styles.picto)}
                    alt="picto viewer"
                    width="auto"
                    height="9em"
                  />
                  <p className={css(styles.buttonBeSomethingRightText)}>
                    {t('pages.home.makerVsWatcher.BeAViewer')}
                  </p>
                </div>
              </Link>
            </span>
          </div>
        )}
        <LoginPopup
          isOpened={isLoginOpened}
          onClose={handleLoginClose}
          onCreateAccount={handleCreateAccount}
          onLoginSuccess={onLoginSuccess}
        />
        <RegisterWatcher
          isOpened={isRegisterOpened}
          onClose={handleRegisterClose}
          onReturn={() => {
            setLoginOpened(true)
            handleRegisterClose()
          }}
          onSubscription={handleSubmitRegister}
        />
        <div className={css(styles.menu)}>
          <UIButton
            label={
              isUserLogged
                ? userRole === 'ubiqeyes_watcher'
                  ? t('pages.home.header.account')
                  : t('common.button.logout')
                : t('common.button.login')
            }
            dynamicStyle={styles.loginButton}
            disabled={INT.AUTH_PERM == false ? true : false}
            textStyle={styles.text}
            onClick={handleLogin}
          />
        </div>
      </div>
    </>
  )
}

WidgetHomeHeader.propTypes = {
  dynamicStyle: PropTypes.object,
  smallSize: PropTypes.node,
  uiLogoDark: PropTypes.node,
  linkStyle: PropTypes.object,
}

export default WidgetHomeHeader
